import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {LazyLoadImage} from 'react-lazy-load-image-component';
import {Case_Arrow} from '../../../app-constants';
import {Link} from 'gatsby';
import Logo1 from "../../images/location_new/caseimg/web-logo-2.webp";
import Img1 from "../../images/location_new/caseimg/web_img2.webp";
import Logo2 from "../../images/location_new/caseimg/web-logo-4.webp";
import Img2 from "../../images/location_new/caseimg/web_img1.webp";
import Logo8 from "../../images/location_new/caseimg/web-logo-3.webp";
import Img8 from "../../images/location_new/caseimg/web_img3.webp";
import Logo9 from "../../images/location_new/caseimg/web-logo-1.webp";
import Img9 from "../../images/location_new/caseimg/web_img4.webp";


const CaseStudy = [
    {
      logo: Logo1,
      title: "The Idea Behind Talpool",
      description:"Talpool is a leading networking platform where models, photographers, makeup artists, designers, and people of other talents can create their portfolios to get the right exposure and find new projects.",
      link: "talpool",
      Img: Img1,
      BgColor: "#FFF0F9",
      TextColor: "#6d4fc1",
    },
    {
      logo: Logo2,
      title: "The Idea Behind Select Dealer Service",
      description: "Select Dealer Service offers a complete partnership for their Dealer clients. They help their clients generate incremental income and offer exemplary services, support, and training.",
      link: "select-dealer",
      Img: Img2,
      BgColor: "#FFF5E8",
      TextColor: "#E56427",
    },
    {
      logo: Logo8,
      title: "The Idea Behind Passion Painting",
      description:"Passion Painting Doesn’t Just Paint Houses, It’s a One Stop Solution.Consider Passion Painting as The Premier Experts In All Kinds Of Interior & Exterior Painting Jobs. Aiming To Make Your House Look As Good As New.",
      link: "passion-painting",
      Img: Img8,
      BgColor: "#EAEAFF",
      TextColor: "#000189",
    },
    {
      logo: Logo9,
      title: "The Idea Behind Al Hussaini",
      description:"Al Hussaini Trading Company stands as a premier marketplace in Saudi Arabia, offering a wide range of watches, jewelry, leather goods, and writing instruments.",
      link: "alhussaini",
      Img: Img9,
      BgColor: "#F7F7F7",
      TextColor: "#020202",
    },
  ];

function Stories(props) {
    return (
        <div className="section_stories p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="m-auto text-center">
                        <div className="example center text-center" data-text="Success">
                            <h2>Success Stories</h2>
                        </div>
                        <p>Being an innovation-driven company with a diverse team of top web developers in the UK, we have forged many success stories throughout the years. Working with influential entrepreneurs and growing businesses, we have always prioritized the maximum outcome based on our web development solutions. Here are some of the proven examples of our products in the industry.:</p>
                    </Col>
                    {CaseStudy.map((item, index) => (
                        <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto" key={index}>
                            <div className="stories_item web-layout" style={{backgroundColor: item.BgColor}}>
                                <div className="item_logo web-img">
                                    <LazyLoadImage
                                        src={item.logo}
                                        effect="blur"
                                        alt={item.title}
                                        className="img-fluid"
                                    />
                                </div>
                                <div className="item_tech">
                                    <div className="tech_content">
                                        <h4 style={{color: item.TextColor}}>{item.title}</h4>
                                        <p>{item.description}</p>
                                        <Link
                                            to={item.link ? `/case-studies/${item.link}` : 'https://www.tekrevol.com/projects'}
                                            className="case_btn"
                                            aria-label="TekRevol Contact">
                                            View Case Study {Case_Arrow}
                                        </Link>
                                    </div>
                                    <div className="tech_img">
                                        <LazyLoadImage
                                            src={item.Img}
                                            effect="blur"
                                            alt={item.title}
                                            className="img-fluid"
                                        />
                                    </div>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </div>
    );
}

export default Stories;
